import { DataSourceParams, GetManyV2Dto } from '@fleet-beat/core';

export interface InfiniteListParamsV2<Extra> extends DataSourceParams<GetManyV2Dto, Extra> {}
